import axios from 'axios';
import { getToken, getMdsToken } from './token.service'
import language from '../config/es';

//constantes
const headers = {
    'Content-Type': 'application/json',
    Authorization: ''
};
// eslint-disable-next-line no-unused-vars
export function getService(url) {
    return new Promise((resolve, reject) => {
        (async () => {
            let token = await getToken(true);
            if (token !== null && token !== undefined) {
                headers.Authorization = 'Bearer ' + token.access_token;

                axios
                    .get(url, {
                        headers: headers,
                        method: 'get'
                    }).then(res => {
                        resolve(res);
                    }).catch(error => {
                        resolve(error);
                    });
            }
        })().catch(reject);
    });

}
export const postService = (url, body) => {
    return new Promise((resolve, reject) => {
        (async () => {
            let token = await getToken(true);
            if (token !== null && token !== undefined) {
                headers.Authorization = 'Bearer ' + token.access_token;
                axios({
                    method: 'post',
                    url: url,
                    data: body,
                    headers: headers
                }).then(res => {
                    resolve(res);
                }).catch(error => {
                    resolve(error);
                });
            }
        })().catch(reject);
    })
}

const postJsonBody = (url, json, verifyToken, obtenerToken = getToken) => {
    return new Promise((resolve, reject) => {
        (async () => {
            let token = await obtenerToken(verifyToken);

            if (token !== null && token !== undefined) {
                headers.Authorization = token.token_type+' ' + token.access_token;

                axios({
                    method: 'post',
                    url: url,
                    data: JSON.stringify(json),
                    mode: 'no-cors',
                    crossDomain: true,
                    headers: headers
                }).then(res => {
                    resolve(res);
                }).catch(error => {
                    resolve(error);
                });
            } else {
                resolve({
                    response:{data:{error: language.messages.error.noToken}}
                });
            }
        })().catch(reject);
    });
}

export const postBodyService = (url, json) => {
    return postJsonBody(url, json, true);
}

export const postBodyServiceWithOutVerification = (url, json) => {
    return postJsonBody(url, json, false);
}

// Igual que postBodyService pero con el token del MDS (modulo de seguridad).
export const postBodyMdsService = (url, json) => {
    return postJsonBody(url, json, true, getMdsToken);
}

export const postBodyMdsServiceWithOutVerification = (url, json) => {
    return postJsonBody(url, json, false, getMdsToken);
}
